import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7885201e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["value", "min", "max"]

import { DateFormat } from '@/views/pages/StudentPages/HomeworkPage/AppendHomeworkPage/append-homework-page.types';
import moment from 'moment';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'date-selector',
  props: {
    modelValue: null,
    props: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'update:modelValue', payload: string): void;
}), expose: any, slots: any, attrs: any }) {

const prop = __props as {
    modelValue: string;
    props: {
        setTodayAsMin: boolean;
        maxDateDaysOffset: number | null;
    };
};





const minDate = computed((): string => {
    return moment(new Date()).format(DateFormat);
});

const maxDate = computed((): string => {
    const today = moment(new Date());
    if (prop.props.maxDateDaysOffset) {
        today.add(prop.props.maxDateDaysOffset, 'days');
    }
    return today.format(DateFormat);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("input", {
    type: "date",
    class: "date-picker",
    onInput: _cache[0] || (_cache[0] = ($event: any) => (
            emit('update:modelValue', ($event.target as HTMLInputElement).value)
        )),
    value: __props.modelValue,
    min: prop.props.setTodayAsMin ? _unref(minDate) : '0000-00-00',
    max: prop.props.maxDateDaysOffset ? _unref(maxDate) : '9999-12-30'
  }, null, 40, _hoisted_1))
}
}

})